import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d6bce7b&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6bce7b')) {
      api.createRecord('6d6bce7b', component.options)
    } else {
      api.reload('6d6bce7b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d6bce7b&", function () {
      api.rerender('6d6bce7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/u8-info-item/index.vue"
export default component.exports